import * as types from "./types";

export function changeTitle(newTitle: string): types.HeaderAction {
  document.title = newTitle;
  return {
    type: types.CHANGE_TITLE,
    title: newTitle,
  };
}

export function openDrawer(): types.HeaderAction {
  return {
    type: types.CHANGE_DRAWER_MENU,
    drawer: true,
  };
}

export function closeDrawer(): types.HeaderAction {
  return {
    type: types.CHANGE_DRAWER_MENU,
    drawer: false,
  };
}

export function rightAction(
  enabled: boolean,
  text?: string,
  action?: () => void,
): types.HeaderAction {
  return {
    type: types.CHANGE_RIGHT_ACTION,
    rightEnabled: enabled,
    rightText: text,
    rightAction: action,
  };
}

export function changeHeader(
  title: string,
  rightEnabled: boolean,
  text: string = null,
  action: () => void = null,
  searchEnabled: boolean = false,
  onSearchText: (txt: string) => void = null,
): types.HeaderAction {
  document.title = title;
  return {
    type: types.CHANGE_HEADER_TITLE_AND_ACTION,
    title: title,
    rightEnabled: rightEnabled,
    rightText: text,
    rightAction: action,
    showSearch: searchEnabled,
    onSearchText: onSearchText,
  } as types.HeaderAction;
}

export function openSnack(title: string): types.HeaderAction {
  return {
    type: types.SHOW_SNACK_TOAST,
    title: title,
  };
}

export function hideSnack(): types.HeaderAction {
  return {
    type: types.HIDE_SNACK_TOAST,
  };
}



// WEBPACK FOOTER //
// ./src/store/header/actions.ts